@if (useStandard) {
  <crm-standard-multi-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValues]="costCenterIds !== null ? null : selectedCostCenters"
    [selectedKeys]="costCenterIds"
    (selectedValuesChange)="onSelected($event)"
    [filtersUiVersion]="filtersUiVersion"
    [labelInput]="!!label"
    [labelInputText]="label || ''"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [class]="class"
    [styleClass]="styleClass"
    [itemStyleClass]="itemStyleClass"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-multi-select>
} @else {
  <crm-multi-select
    [filtersUiVersion]="filtersUiVersion"
    [styleClass]="styleClass"
    [class]="class"
    [label]="label"
    [showClear]="showClear"
    [appendTo]="appendTo"
    [options]="costCenters"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [itemStyleClass]="itemStyleClass"
    [isError]="isError"
    [selectedItems]="selectedCostCenters"
    (selectedItemsChange)="onSelected($event)"
    [loading]="loading || selectionLoading"></crm-multi-select>
}
